import { StudentInternShipKeyDetails } from "./student-internship-key-details-model";


export class StudentFeedback{
    subtitle ='Student Feedback';
    isStudentCompletedInternship = 'Have you completed your Internship?';
    keyDetails:StudentInternShipKeyDetails[] = []
}